/**
 * @generated SignedSource<<1d8d38de2b0e4e1ee64de8060ae4229b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TeeSheetBasedFiltersModalFragment_facility$data = {
  readonly club: {
    readonly supportsPrivate: boolean;
  } | null | undefined;
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"AgendaDateSelectorControlFragment_facility" | "TeeSheetCourseSelectorControlFragment_facility" | "TeeSheetHoleCountSelectorControl_facility" | "TeeSheetMultipleBookingToggleFragment_Facility" | "facilityToScheduleOption_facility" | "useFacilityGroupSize_facility" | "useFacilityStartEndTime_facility">;
  readonly " $fragmentType": "TeeSheetBasedFiltersModalFragment_facility";
};
export type TeeSheetBasedFiltersModalFragment_facility$key = {
  readonly " $data"?: TeeSheetBasedFiltersModalFragment_facility$data;
  readonly " $fragmentSpreads": FragmentRefs<"TeeSheetBasedFiltersModalFragment_facility">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TeeSheetBasedFiltersModalFragment_facility",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Club",
      "kind": "LinkedField",
      "name": "club",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "supportsPrivate",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useFacilityStartEndTime_facility"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useFacilityGroupSize_facility"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TeeSheetCourseSelectorControlFragment_facility"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TeeSheetMultipleBookingToggleFragment_Facility"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AgendaDateSelectorControlFragment_facility"
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "facilityToScheduleOption_facility",
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "slug",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Department",
          "kind": "LinkedField",
          "name": "department",
          "plural": false,
          "selections": [
            (v1/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "args": null,
      "argumentDefinitions": []
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TeeSheetHoleCountSelectorControl_facility"
    }
  ],
  "type": "Facility",
  "abstractKey": null
};
})();

(node as any).hash = "414fbaedff3538693788c062f57f1008";

export default node;
